import PaymentAbstractDialog from "./PaymentAbstractDialog";

export default class ReturnPaymentDialog extends PaymentAbstractDialog {

    title = "invoice.returnPayment";
    dialogSaveLabel = "invoice.confirmRefund";

    get balanceLabel() {
        return "invoice.refundSource";
    }

    showZeroItem() {
        return false;
    }
    
    joinSaveInfo(info) {
        return {
            ...info,
            direction: "DIRECTION_GET",
        };
    }
}
